import { Card, CardContent, Grid, Icon, Typography} from '@mui/material';
import React from 'react'
import { CreditCard, Filter, Search, TrendingDown, TrendingUp, User } from 'react-feather';
import { AllowedAccess } from 'react-permission-role';
import { useLocation, useParams } from 'react-router-dom';
// import { FilterPayments } from './PaymentsFilter/FilterPayments';
import { useFechInitVehicleCredits } from './hooks';
import { LogBook } from './Logbook/LogBook';
import { Expenses } from './Expenses/Expenses';
import { VehiclesUncollectibleCreditsTable } from './VehiclesUncollectibleCreditsTable/VehiclesUncollectibleCreditsTable';
import { VehicleUncollectibleCreditForm } from './VehicleForm/VehicleForm';
// import { ModalModule } from './Modal';

export const AdminUncollectibleCredits = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitVehicleCredits({location, paramsURL})
  
  const {globalStates:{showForm, showLogBook, showExpenses}} = useFetchInit

  return (
    <AllowedAccess permissions={['49_ADMIN', '209_VEHICULOS_CREDITOS_INCOBRABLES']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
      {!(showForm || showLogBook || showExpenses) && (
        <div className='panel-body' id='listadoregistros'>
          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>
                <CardContent>
                  {/* <ModalModule useFetchInit={useFetchInit} /> */}

                  <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt:1, mb:3}}>
                    <Typography variant='h4' sx={{ display: 'flex', alignItems: 'center' }}>
                      Creditos Incobrables de Vehiculos
                      <Icon component={TrendingDown} sx={{ ml: 1, fontSize: '1.5rem' }} />
                    </Typography>
                  </Grid>
                  <VehiclesUncollectibleCreditsTable useFetchInit={useFetchInit}/>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
        )}
        {(showForm) && (
          <>
              <div className='panel-body' id='formularioregistros'>
                  <VehicleUncollectibleCreditForm 
                      useFetchInit={useFetchInit} 
                  />
              </div>
          </>
        )}
        {(showLogBook) && (
          <>
              <div className='panel-body' style={{ height: '100%', overflow: 'hidden' }} >
                  <LogBook 
                      useFetchInit={useFetchInit} 
                  />
              </div>
          </>
        )}
        {(showExpenses) && (
          <>
              <div className='panel-body' style={{ height: '100%', overflow: 'hidden' }} >
                  <Expenses 
                      useFetchInit={useFetchInit} 
                  />
              </div>
          </>
        )}
      </div>
    </AllowedAccess>
  )
}
